export class Unserializer {
  static date(v: Date | string | null): Date | null {
    if (v === null) {
      return null;
    } else if (v instanceof Date) {
      return new Date(v);
    } else {
      const s = String(v);
      return new Date(s + (s.match(/[zZ]$/) ? '' : 'z'));
    }
  }
}

